// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CB2wM","col":"styles_col__35hb5"};